import React from "react";

const IconGenericCC = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fillRule="nonzero"
                style={{fill: props?.iconFill}}
                d="M0 8V5a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v3zm24 3v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-8zM9 17H3v1h6zm3-2H3v1h9zm9 0h-3v1h3z">
            </path>
        </svg>
    )
};

export default IconGenericCC;
